/**
 * The Android app (Capacitor shell around this same web app — N-PAC, 4 Nov 2026: "मोबाइल के APK फाइल बन
 * जाए"). In a browser none of this is used: `isNative()` is false and the web pieces (navigator.geolocation,
 * Wake Lock) do the work. In the APK, the driver's GPS runs through the background-geolocation plugin: a
 * foreground service with a notification, so the fixes keep coming with the screen locked ("मोबाइल लॉक कर दे
 * … जीपीएस ट्रैकिंग बैकग्राउंड में चलता रहे").
 */
import { Capacitor, registerPlugin } from "@capacitor/core";
import type { GeoLike } from "../field/drive";

export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

type BgLocation = { latitude: number; longitude: number; accuracy: number; speed: number | null; time: number | null };
type BgError = { code?: string; message?: string };
interface BackgroundGeolocationPlugin {
  addWatcher(
    opts: { backgroundTitle?: string; backgroundMessage?: string; requestPermissions?: boolean; stale?: boolean; distanceFilter?: number },
    cb: (location?: BgLocation, error?: BgError) => void
  ): Promise<string>;
  removeWatcher(o: { id: string }): Promise<void>;
  openSettings(): Promise<void>;
}

let plugin: BackgroundGeolocationPlugin | null = null;
function bg(): BackgroundGeolocationPlugin {
  return (plugin ??= registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation"));
}

/**
 * GPS that keeps running with the screen off, as the tracker's `GeoLike`: only in the APK (null in a browser).
 * The notification's title / text is what the driver sees while the duty is on.
 */
export function backgroundGeo(text: { title: string; message: string }): GeoLike | null {
  if (!isNative()) return null;
  let n = 0;
  const ids = new Map<number, Promise<string>>();
  return {
    watchPosition(ok, err) {
      const id = ++n;
      const p = bg()
        .addWatcher({ backgroundTitle: text.title, backgroundMessage: text.message, requestPermissions: true, stale: false, distanceFilter: 10 }, (loc, e) => {
          if (e) {
            err({ code: e.code === "NOT_AUTHORIZED" ? 1 : 2 });
            return;
          }
          if (loc) ok({ coords: { latitude: loc.latitude, longitude: loc.longitude, accuracy: loc.accuracy, speed: loc.speed }, timestamp: loc.time ?? Date.now() });
        })
        .catch((e) => {
          err({ code: 2 });
          throw e;
        });
      ids.set(id, p);
      return id;
    },
    clearWatch(id) {
      const p = ids.get(id);
      ids.delete(id);
      void p?.then((wid) => bg().removeWatcher({ id: wid })).catch(() => undefined);
    },
  };
}

/** the phone's location settings (when the driver refused the permission) */
export function openLocationSettings() {
  if (isNative()) void bg().openSettings().catch(() => undefined);
}
